(function () {
  var THEME_STORAGE_KEY = 'rmw-color-theme';

  function toggleBodyScroll(locked) {
    document.body.classList.toggle('mobile-nav-open', locked);
  }

  function getStoredTheme() {
    try {
      return window.localStorage.getItem(THEME_STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function storeTheme(theme) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (error) {
      // Intentionally empty: theme persistence is optional.
    }
  }

  function getPreferredTheme() {
    var storedTheme = getStoredTheme();

    if (storedTheme === 'light' || storedTheme === 'dark') {
      return storedTheme;
    }

    return 'light';
  }

  function applyTheme(theme) {
    var nextTheme = theme === 'dark' ? 'dark' : 'light';
    var isDark = nextTheme === 'dark';

    document.body.classList.toggle('theme-dark', isDark);
    document.documentElement.setAttribute('data-theme', nextTheme);

    document.querySelectorAll('[data-theme-toggle]').forEach(function (button) {
      var nextLabel = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      var labelNode = button.querySelector('[data-theme-toggle-label]');

      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', nextLabel);

      if (labelNode) {
        labelNode.textContent = nextLabel;
      }
    });
  }

  function initThemeToggle(root) {
    var toggles = root.querySelectorAll('[data-theme-toggle]');

    if (!document.documentElement.dataset.themeInitialized) {
      applyTheme(getPreferredTheme());

      document.documentElement.dataset.themeInitialized = 'true';
    } else if (toggles.length) {
      applyTheme(document.body.classList.contains('theme-dark') ? 'dark' : 'light');
    }

    toggles.forEach(function (button) {
      if (button.dataset.themeToggleBound === 'true') return;

      button.addEventListener('click', function () {
        var nextTheme = document.body.classList.contains('theme-dark') ? 'light' : 'dark';
        applyTheme(nextTheme);
        storeTheme(nextTheme);
      });

      button.dataset.themeToggleBound = 'true';
    });
  }

  function initMobileNavigation(root) {
    var headers = root.querySelectorAll('[data-site-header]');

    headers.forEach(function (header) {
      if (header.dataset.navInitialized === 'true') return;

      var toggleButton = header.querySelector('[data-mobile-menu-toggle]');
      var drawer = header.querySelector('[data-mobile-drawer]');
      var closeButtons = header.querySelectorAll('[data-mobile-menu-close]');

      if (!toggleButton || !drawer) {
        header.dataset.navInitialized = 'true';
        return;
      }

      function setOpenState(isOpen) {
        toggleButton.setAttribute('aria-expanded', String(isOpen));
        drawer.setAttribute('aria-hidden', String(!isOpen));

        if (isOpen) {
          drawer.hidden = false;
          requestAnimationFrame(function () {
            drawer.classList.add('is-open');
          });
        } else {
          drawer.classList.remove('is-open');
          window.setTimeout(function () {
            drawer.hidden = true;
          }, 180);
        }

        toggleBodyScroll(isOpen);
      }

      toggleButton.addEventListener('click', function () {
        var isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
        setOpenState(!isExpanded);
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setOpenState(false);
        });
      });

      drawer.querySelectorAll('a[href]').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpenState(false);
        });
      });

      drawer.addEventListener('click', function (event) {
        if (event.target === drawer) {
          setOpenState(false);
        }
      });

      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      header.dataset.navInitialized = 'true';
    });

    if (!document.documentElement.dataset.navEscapeBound) {
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;

        document.querySelectorAll('[data-site-header]').forEach(function (header) {
          var button = header.querySelector('[data-mobile-menu-toggle]');
          var drawer = header.querySelector('[data-mobile-drawer]');
          if (!button || !drawer) return;

          if (button.getAttribute('aria-expanded') === 'true') {
            button.setAttribute('aria-expanded', 'false');
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            window.setTimeout(function () {
              drawer.hidden = true;
            }, 180);
            toggleBodyScroll(false);
          }
        });
      });

      window.addEventListener('resize', function () {
        if (!window.matchMedia('(min-width: 990px)').matches) return;

        document.querySelectorAll('[data-site-header]').forEach(function (header) {
          var button = header.querySelector('[data-mobile-menu-toggle]');
          var drawer = header.querySelector('[data-mobile-drawer]');
          if (!button || !drawer) return;
          button.setAttribute('aria-expanded', 'false');
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.hidden = true;
        });

        toggleBodyScroll(false);
      });

      document.documentElement.dataset.navEscapeBound = 'true';
    }
  }

  function initQuantityInputs(root) {
    var wrappers = root.querySelectorAll('[data-quantity-input]');

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.quantityInitialized === 'true') return;

      var input = wrapper.querySelector('input[type="number"]');
      if (!input) {
        wrapper.dataset.quantityInitialized = 'true';
        return;
      }

      wrapper.addEventListener('click', function (event) {
        var button = event.target.closest('[data-quantity-change]');
        if (!button) return;

        var delta = Number(button.getAttribute('data-quantity-change'));
        if (Number.isNaN(delta)) return;

        var min = Number(input.min || 1);
        var max = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
        var step = Number(input.step || 1);
        var value = Number(input.value || min);

        value += delta * step;
        if (value < min) value = min;
        if (value > max) value = max;

        input.value = String(value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      wrapper.dataset.quantityInitialized = 'true';
    });
  }

  function initProductSections(root) {
    var sections = root.querySelectorAll('[data-product-section]');

    sections.forEach(function (section) {
      if (section.dataset.productInitialized === 'true') return;

      var variantSelect = section.querySelector('[data-variant-select]');
      var variantPills = section.querySelectorAll('[data-variant-pill]');
      var priceEl = section.querySelector('[data-product-price]');
      var comparePriceEl = section.querySelector('[data-product-compare-price]');
      var statusEl = section.querySelector('[data-product-status]');
      var submitButton = section.querySelector('[data-product-submit]');
      var submitLabel = section.querySelector('[data-product-submit-label]');
      var mediaItems = section.querySelectorAll('[data-product-media-id]');
      var thumbButtons = section.querySelectorAll('[data-product-thumb]');
      var prevMediaButton = section.querySelector('[data-product-media-prev]');
      var nextMediaButton = section.querySelector('[data-product-media-next]');

      function syncVariantPills(variantId) {
        if (!variantPills.length) return;

        variantPills.forEach(function (pill) {
          var isSelected = String(pill.getAttribute('data-variant-id')) === String(variantId);
          pill.classList.toggle('is-active', isSelected);
          pill.setAttribute('aria-pressed', String(isSelected));
        });
      }

      function setActiveMedia(mediaId) {
        if (!mediaId) return;

        mediaItems.forEach(function (item) {
          item.classList.toggle('is-active', String(item.getAttribute('data-product-media-id')) === String(mediaId));
        });

        thumbButtons.forEach(function (button) {
          button.classList.toggle('is-active', String(button.getAttribute('data-product-thumb')) === String(mediaId));
          button.setAttribute(
            'aria-current',
            String(button.getAttribute('data-product-thumb')) === String(mediaId) ? 'true' : 'false'
          );
        });
      }

      function moveMediaBy(step) {
        if (!mediaItems.length) return;

        var activeIndex = 0;
        mediaItems.forEach(function (item, index) {
          if (item.classList.contains('is-active')) {
            activeIndex = index;
          }
        });

        var nextIndex = (activeIndex + step + mediaItems.length) % mediaItems.length;
        var nextMediaId = mediaItems[nextIndex].getAttribute('data-product-media-id');
        setActiveMedia(nextMediaId);
      }

      function updateVariantState(option) {
        if (!option) return;

        var isAvailable = option.getAttribute('data-available') === 'true';
        var soldOutText = section.getAttribute('data-label-sold-out') || 'Sold out';
        var unavailableText = section.getAttribute('data-label-unavailable') || 'Unavailable';
        var addToCartText = section.getAttribute('data-label-add-to-cart') || 'Add to cart';
        var mediaId = option.getAttribute('data-media-id');
        var comparePrice = option.getAttribute('data-compare-price');

        if (priceEl) {
          priceEl.textContent = option.getAttribute('data-price') || '';
        }

        if (comparePriceEl) {
          if (comparePrice) {
            comparePriceEl.hidden = false;
            comparePriceEl.textContent = comparePrice;
          } else {
            comparePriceEl.hidden = true;
            comparePriceEl.textContent = '';
          }
        }

        if (submitButton) {
          submitButton.disabled = !isAvailable;
        }

        if (submitLabel) {
          submitLabel.textContent = isAvailable ? addToCartText : soldOutText;
        }

        if (submitButton && submitLabel) {
          submitButton.setAttribute('aria-label', submitLabel.textContent.trim());
        }

        if (statusEl) {
          if (isAvailable) {
            statusEl.textContent = comparePrice ? 'On sale' : '';
          } else {
            statusEl.textContent = soldOutText || unavailableText;
          }
        }

        if (mediaId) {
          setActiveMedia(mediaId);
        }

        syncVariantPills(option.value);

        if (variantSelect && variantSelect.value) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantSelect.value);
          window.history.replaceState({}, '', url.toString());
        }
      }

      thumbButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setActiveMedia(button.getAttribute('data-product-thumb'));
        });
      });

      if (prevMediaButton) {
        prevMediaButton.addEventListener('click', function () {
          moveMediaBy(-1);
        });
      }

      if (nextMediaButton) {
        nextMediaButton.addEventListener('click', function () {
          moveMediaBy(1);
        });
      }

      if (variantSelect) {
        variantPills.forEach(function (pill) {
          pill.addEventListener('click', function () {
            var variantId = pill.getAttribute('data-variant-id');
            if (!variantId) return;

            variantSelect.value = variantId;
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        variantSelect.addEventListener('change', function () {
          var option = variantSelect.options[variantSelect.selectedIndex];
          updateVariantState(option);
        });

        updateVariantState(variantSelect.options[variantSelect.selectedIndex]);
      }

      section.dataset.productInitialized = 'true';
    });
  }

  function initProductCardTransitions(root) {
    var links = root.querySelectorAll('.product-card__link[href]');

    links.forEach(function (link) {
      if (link.dataset.productTransitionBound === 'true') return;

      link.addEventListener('click', function (event) {
        if (event.defaultPrevented) return;
        if (event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.target && link.target !== '_self') return;

        var href = link.getAttribute('href');
        if (!href) return;

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }

        var destinationUrl;
        try {
          destinationUrl = new URL(href, window.location.href);
        } catch (error) {
          return;
        }

        if (destinationUrl.origin !== window.location.origin) return;

        event.preventDefault();
        document.body.classList.add('is-product-transitioning');
        link.classList.add('is-opening');

        window.setTimeout(function () {
          window.location.href = destinationUrl.toString();
        }, 180);
      });

      link.dataset.productTransitionBound = 'true';
    });
  }

  function initProductCardGalleries(root) {
    if (!document.body.classList.contains('template-index')) return;

    var galleries = root.querySelectorAll('[data-product-card-gallery]');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.cardGalleryInitialized === 'true') return;

      var images = gallery.querySelectorAll('.product-card__image');
      var prevButton = gallery.querySelector('[data-product-card-prev]');
      var nextButton = gallery.querySelector('[data-product-card-next]');

      if (images.length < 2 || !prevButton || !nextButton) {
        gallery.dataset.cardGalleryInitialized = 'true';
        return;
      }

      var activeIndex = 0;

      function setActive(index) {
        activeIndex = index;

        images.forEach(function (image, imageIndex) {
          var isActive = imageIndex === activeIndex;
          image.classList.toggle('is-active', isActive);
          image.setAttribute('aria-hidden', String(!isActive));
        });
      }

      function moveBy(step) {
        var nextIndex = (activeIndex + step + images.length) % images.length;
        setActive(nextIndex);
      }

      function bindControl(button, step) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          moveBy(step);
          button.blur();
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          moveBy(step);
        });
      }

      bindControl(prevButton, -1);
      bindControl(nextButton, 1);
      setActive(activeIndex);
      gallery.dataset.cardGalleryInitialized = 'true';
    });
  }

  function syncSelectedCity(dropdown) {
    var selectedOption = dropdown.querySelector('[data-city-option].is-selected');
    if (!selectedOption) return;

    var currentName = dropdown.querySelector('[data-city-current-name]');
    var currentTemp = dropdown.querySelector('[data-city-current-temp]');
    var currentTime = dropdown.querySelector('[data-city-current-time]');
    var optionTemp = selectedOption.querySelector('[data-city-option-temp]');
    var optionTime = selectedOption.querySelector('[data-city-option-time]');
    var selectedName = selectedOption.getAttribute('data-city-name') || selectedOption.textContent.trim();

    if (currentName) {
      currentName.textContent = selectedName;
    }

    if (currentTemp && optionTemp) {
      currentTemp.textContent = optionTemp.textContent;
    }

    if (currentTime && optionTime) {
      currentTime.textContent = optionTime.textContent;
    }
  }

  function getCityTimeParts(formatter, now) {
    if (!formatter || typeof formatter.formatToParts !== 'function') return null;

    var timeParts = { hour: 0, minute: 0, second: 0 };
    var formattedParts = formatter.formatToParts(now);

    formattedParts.forEach(function (part) {
      if (part.type !== 'hour' && part.type !== 'minute' && part.type !== 'second') return;

      var parsedValue = parseInt(part.value, 10);

      if (!isNaN(parsedValue)) {
        timeParts[part.type] = parsedValue;
      }
    });

    if (timeParts.hour === 24) {
      timeParts.hour = 0;
    }

    return timeParts;
  }

  function setClockHands(option, timeParts) {
    if (!timeParts) return;

    var hourHand = option.querySelector('[data-city-hour-hand]');
    var minuteHand = option.querySelector('[data-city-minute-hand]');
    var secondHand = option.querySelector('[data-city-second-hand]');

    if (!hourHand || !minuteHand || !secondHand) return;

    var hourValue = timeParts.hour % 12;
    var minuteValue = timeParts.minute;
    var secondValue = timeParts.second;
    var hourRotation = hourValue * 30 + minuteValue * 0.5;
    var minuteRotation = minuteValue * 6 + secondValue * 0.1;
    var secondRotation = secondValue * 6;

    hourHand.style.transform = 'translateX(-50%) rotate(' + hourRotation + 'deg)';
    minuteHand.style.transform = 'translateX(-50%) rotate(' + minuteRotation + 'deg)';
    secondHand.style.transform = 'translateX(-50%) rotate(' + secondRotation + 'deg)';
  }

  function updateCityTimes() {
    var timeFormatters = window.__cityTimeFormatters || {};
    var optionButtons = document.querySelectorAll('[data-city-option]');
    var now = new Date();

    optionButtons.forEach(function (option) {
      var timezone = option.getAttribute('data-city-timezone');
      var optionTime = option.querySelector('[data-city-option-time]');
      var timeText = '--';
      var timeParts = null;

      if (!timezone) return;

      if (!timeFormatters[timezone]) {
        try {
          timeFormatters[timezone] = {
            label: new Intl.DateTimeFormat('en-US', {
              weekday: 'short',
              hour: 'numeric',
              minute: '2-digit',
              second: '2-digit',
              timeZone: timezone,
            }),
            parts: new Intl.DateTimeFormat('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false,
              timeZone: timezone,
            }),
          };
        } catch (error) {
          timeFormatters[timezone] = null;
        }
      }

      if (timeFormatters[timezone]) {
        timeText = timeFormatters[timezone].label
          .format(now)
          .replace(/,\s*/, ' ')
          .replace(/\s*AM$/, ' am')
          .replace(/\s*PM$/, ' pm');
        timeParts = getCityTimeParts(timeFormatters[timezone].parts, now);
      }

      if (optionTime) {
        optionTime.textContent = timeText;
      }

      setClockHands(option, timeParts);
    });

    window.__cityTimeFormatters = timeFormatters;

    document.querySelectorAll('[data-city-dropdown]').forEach(function (dropdown) {
      syncSelectedCity(dropdown);
    });
  }

  function fetchCityTemperature(option) {
    var latitude = option.getAttribute('data-city-lat');
    var longitude = option.getAttribute('data-city-lon');
    var optionTemp = option.querySelector('[data-city-option-temp]');

    if (!latitude || !longitude || !optionTemp || !window.fetch) return Promise.resolve();

    var url =
      'https://api.open-meteo.com/v1/forecast?latitude=' +
      encodeURIComponent(latitude) +
      '&longitude=' +
      encodeURIComponent(longitude) +
      '&current=temperature_2m&temperature_unit=fahrenheit';

    return window
      .fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Temperature request failed');
        }
        return response.json();
      })
      .then(function (data) {
        var temp = data && data.current ? data.current.temperature_2m : null;
        if (typeof temp === 'number') {
          optionTemp.textContent = Math.round(temp) + '°F';
        }
      })
      .catch(function () {
        optionTemp.textContent = '--';
      });
  }

  function refreshCityTemperatures() {
    var options = document.querySelectorAll('[data-city-option]');
    var requests = [];

    options.forEach(function (option) {
      requests.push(fetchCityTemperature(option));
    });

    Promise.all(requests).then(function () {
      document.querySelectorAll('[data-city-dropdown]').forEach(function (dropdown) {
        syncSelectedCity(dropdown);
      });
    });
  }

  function initCityDropdown(root) {
    var dropdowns = root.querySelectorAll('[data-city-dropdown]');

    dropdowns.forEach(function (dropdown) {
      if (dropdown.dataset.cityDropdownInitialized === 'true') return;

      var trigger = dropdown.querySelector('[data-city-trigger]');
      var panel = dropdown.querySelector('[data-city-panel]');
      var optionButtons = dropdown.querySelectorAll('[data-city-option]');
      var closeTimerId;

      if (!trigger || !panel || !optionButtons.length) {
        dropdown.dataset.cityDropdownInitialized = 'true';
        return;
      }

      function setOpenState(isOpen, immediate) {
        trigger.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          if (closeTimerId) {
            window.clearTimeout(closeTimerId);
            closeTimerId = null;
          }

          panel.hidden = false;
          window.requestAnimationFrame(function () {
            panel.classList.add('is-open');
          });
          return;
        }

        panel.classList.remove('is-open');

        if (closeTimerId) {
          window.clearTimeout(closeTimerId);
          closeTimerId = null;
        }

        if (immediate) {
          panel.hidden = true;
          return;
        }

        closeTimerId = window.setTimeout(function () {
          if (trigger.getAttribute('aria-expanded') === 'false') {
            panel.hidden = true;
          }
        }, 180);
      }

      function setSelectedOption(selectedButton) {
        optionButtons.forEach(function (button) {
          var isSelected = button === selectedButton;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
        });

        syncSelectedCity(dropdown);
      }

      if (!dropdown.querySelector('[data-city-option].is-selected')) {
        setSelectedOption(optionButtons[0]);
      } else {
        syncSelectedCity(dropdown);
      }

      trigger.addEventListener('click', function () {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        setOpenState(!isExpanded);
      });

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setSelectedOption(button);
          setOpenState(false);
        });
      });

      document.addEventListener('click', function (event) {
        if (!dropdown.contains(event.target)) {
          setOpenState(false);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setOpenState(false);
        }
      });

      setOpenState(false, true);
      dropdown.dataset.cityDropdownInitialized = 'true';
    });

    if (!document.documentElement.dataset.cityWeatherInitialized) {
      refreshCityTemperatures();
      updateCityTimes();

      window.setInterval(function () {
        updateCityTimes();
      }, 1000);

      window.setInterval(function () {
        refreshCityTemperatures();
      }, 600000);

      document.documentElement.dataset.cityWeatherInitialized = 'true';
    } else {
      updateCityTimes();
    }
  }

  function initAll(root) {
    initThemeToggle(root);
    initMobileNavigation(root);
    initCityDropdown(root);
    initQuantityInputs(root);
    initProductSections(root);
    initProductCardGalleries(root);
    initProductCardTransitions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
